module.exports = __webpack_public_path__ + "static/images/404.756bf23.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/404.png
// module id = CgFv
// module chunks = 11